var productName = 'scheduler';// region WebComponents
export { default as WidgetTag } from '../lib/Core/customElements/WidgetTag.js';
// endregion
